export const Palette:{[key:string]: string} = {
  gray: "#F8F8F8",
  green: "#2ecc71",
  darkGray: "#B8B8B8",
  red: "#D90202",
  blue: "#091335",
  orange: "#B94D26",
  transparentBlue: '#335EF714'
};
